import { Authenticated } from "@refinedev/core";
import { useParams } from "react-router-dom";
import { ProjectCreateWizard } from "./components/ProjectCreateWizard";
import { ProjectCreationPage } from "./components/ProjectCreationPage";

export const ProjectCreate = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <Authenticated key="projectCreate">
      {id ? <ProjectCreateWizard /> : <ProjectCreationPage />}
    </Authenticated>
  );
};
